import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CountriesModel } from '@app/pages/main/pages/startup-countries/models/countries.interfaces';
import { IStatus } from '@app/origami-api/constants/statuses';
import { StatusColors } from '@app/shared/ui/simple-components/status/status-models';
import { ItemDisabledFn } from '@progress/kendo-angular-dropdowns';
import IData = CountriesModel.IData;
import IStatusData = CountriesModel.IStatusData;

export interface IStatusWithColor extends IData {
  color: StatusColors;
}

type Status<TStatusEnum> = IData[] | IStatusData[] | IStatus<TStatusEnum>[] | IStatusWithColor[];

@Component({
  standalone: false,
  selector: 'ti-status-dropdown',
  templateUrl: './status-dropdown.component.html',
  styleUrls: ['./status-dropdown.component.sass'],
})
export class StatusDropdownComponent<TStatusEnum = any> {
  @Input() public topicTypeId?: number;
  @Input() public entityName?: string;
  @Input() controlName?: string;
  @Input() formName?: FormGroup;
  @Input() dropdownData: Status<TStatusEnum>;
  @Input() itemDisabled: ItemDisabledFn = () => false;
  @Input() selectedValue?: any;
  @Output() statusValueChange = new EventEmitter<Status<TStatusEnum>>();

  public onValueChange(event: Status<TStatusEnum>): void {
    this.statusValueChange.emit(event);
  }
}
